import { menuLoadingPending, menuLoadingSuccess, menuLoadingFail } from '../../redux/features/menuSlice';
import { getMenuData } from '../apis/menuApi';

export const getMenusAction = (userTokenAuth) => async (dispatch) => {
    try {
        dispatch(menuLoadingPending());
        const result = await getMenuData(userTokenAuth);
        if (result.status === "Ok") {
            dispatch(menuLoadingSuccess(result.data));
        } else {
            dispatch(menuLoadingFail(result.errorMessage))
        }
        return result

    } catch (error) {
        dispatch(menuLoadingFail(error.message));
    }
};